import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportsRoutingModule } from './reports-routing.module';
import { ReportsComponent } from './reports.component';
import { DetailReportComponent } from './detail-report/detail-report.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SharedModule } from '../shared/shared.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
// import { DropdownMenusModule } from 'src/app/_metronic/partials';


@NgModule({
  declarations: [
    ReportsComponent,
    DetailReportComponent
  ],
  imports: [
    CommonModule,
    ReportsRoutingModule,
    FormsModule,
    InfiniteScrollModule,
    SharedModule,
    ReactiveFormsModule,
    // DropdownMenusModule,
    NgMultiSelectDropDownModule.forRoot(),
  ]
})
export class ReportsModule { }
